exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n  list-style-type: none;\n}\n.form-control-sm {\n  width: inherit !important;\n}\n.custom-control {\n  margin-left: 20px !important;\n  display: inline-block !important;\n}\n", ""]);

// exports
